const { define, h, Component } = omii;

export default class extends Component{
    
}